export interface IBaseModel {
    Id?: number;
}

export class BaseModel<T> {
  constructor(param?: T) {
    if (param !== undefined)
      Object.keys(param).forEach(key => this[key] = param[key]);
  }
}

